// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".style > > > .v-input__slot[data-v-44ddd366]::before {\n  border-style: none !important;\n}", ""]);
// Exports
module.exports = exports;
